import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { updatePersonalDetails, UPDATE_PERSONAL_DETIALS} from "../../actions/student.action"

function* handleUpdatePersonalDetails(action) {
  try {
    const { data : resData} = yield call(studentAPI.updatePersonalDetails, action.payload);
    //extract the data here     
    yield put(updatePersonalDetails.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(updatePersonalDetails.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* updatePersonalDetailsSaga() {
  yield takeLatest(UPDATE_PERSONAL_DETIALS.REQUEST, handleUpdatePersonalDetails);
}

export default updatePersonalDetailsSaga;
